import { render, staticRenderFns } from "./TimestampColumnRenderer.vue?vue&type=template&id=0c12a256&"
import script from "./TimestampColumnRenderer.vue?vue&type=script&lang=js&"
export * from "./TimestampColumnRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports